<template>
  <div class="cBalance">
    <div class="head">
      <div class="head_a rule-box">
        <div class="pll"  @click="onReturn()">
          <Icon type="ios-arrow-back" />
        </div>
        我的红包
      </div>
      <div class="head_b">
        红包余额（元）
      </div>
      <div class="head_c">
        <span>
         {{na}}
        </span>
        <span>
         .{{nb}}
        </span>
      </div>
      <div class="head_d">
        <div class="other">
            <div>
              {{udata.other_balance}}
            </div>
            <div>
              健康设备
            </div>
        </div>
        <div class="onepx">

        </div>
        <div class="other">
            <div>
                {{udata.jn_balance}}
            </div>
            <div>
                健康服务
            </div>
        </div>
      </div>
    </div>
    <div class="body">
      <ul>
        <li @click="toReflect">
          <img class="tu1" :src="img" alt="">
          <div>申请提现</div>
          <img class="tu2" :src="img2" alt="">
        </li>
        <li @click="toDetail">
          <img class="tu1" :src="img1" alt="">
          <div>余额明细</div>
          <img class="tu2" :src="img2" alt="">
        </li>
        <li @click="Transfer">
          <img class="tu1" :src="transferIcon" alt="">
          <div>转赠</div>
          <img class="tu2" :src="img2" alt="">
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      img:require('@/assets/img/tx.png'),
      img1:require('@/assets/img/mx.png'),
      img2:require('@/assets/img/r.png'),
      transferIcon:require('@/assets/img/transfer.png'),
      udata:[],
      na:'----',
      nb:'--',
    }
  },
  methods: {
    isAndroid_ios(){   //区别iOS and
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      } else if (isIOS) {
        return false;
      }
    },

    onReturn(){
      if(this.isAndroid_ios()) {
        console.log('安卓')
        window.local_obj.onReturn('1')
      }else {
        console.log('ios')
        window.webkit.messageHandlers.onReturn.postMessage(null); //ios
      }

    },

    toDecimal2(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x*100)/100;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 2) {
        s += '0';
      }
      return s;
    },
    async load(){
      console.log(111)
      const self = this
      const res = await this.$ajax.post('/api/Retail/balance',{uid:this.$route.query.uid})
      console.log('resresresres')

      this.udata = res.content
      let str = self.udata.balance.split('.');
      self.na = str[0]
      if(str[1] == undefined){
        self.nb = '00'
      } else {
        self.nb = str[1]
      }
      console.log(res)
    },
    toReflect(){
      this.$router.push({
        path:'/Reflect',
        query:{
          uid:this.$route.query.uid
        }
      })
    },
    toDetail(){
      this.$router.push({
        path:'/DetailsOfBalance',
        query:{
        uid:this.$route.query.uid
      }
      })
    },
    Transfer() {
      this.$router.push({
        path:'/Transfer',
        query:{
          uid:this.$route.query.uid
        }
      })
    }
  },
  mounted() {
    this.load()
    console.log(this.$route.query.uid)
  },
}
</script>

<style lang="less" scoped>
.cBalance{
  display: flex;
  flex-direction: column;
  background:rgba(249,249,249,1);
  height: 100vh;
}
  .head{
    // width:100%;
    box-sizing: border-box;
    height:17.75rem;
    background:rgba(255,119,155,1);
    padding-top: 2.5rem;
    position: relative;
    // overflow: hidden;
      .head_a{
        font-size:1.0625rem;
        font-family:zitix;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:1.375rem;
        letter-spacing:0.0625rem;
        margin-bottom: 1.875rem;
      }
      .head_b{
        font-size:0.875rem;
        font-family:ziti;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:1.25rem;
        text-align: start;
        padding-left: 3.5vw;
        margin-bottom: 3vw;
      }
      .head_c{
        font-size:3.75rem;
        font-family:zitix;
        font-weight:bold;
        color:rgba(255,255,255,1);
        line-height:4.0625rem;
        text-align: start;
        padding-left: 3vw;
          >span:nth-child(1){
            padding: 0;
          }
          >span:last-child{
            font-size:2rem;
          }
      }
      .head_d{
        width:94vw;
        height:8rem;
        background:rgba(255,255,255,1);
        box-shadow:0px 0.375rem 0.75rem 0px rgba(0,0,0,0.08);
        border-radius:0.3125rem;
        margin-left: 3vw;
        // margin-right: 0.9375rem;
        position: absolute;
        bottom: -3.75rem;
        display: flex;
        justify-content: space-between;

          .other{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
              >div:nth-child(1){
                width:4.9375rem;
                height:2.125rem;
                font-size:1.5rem;
                font-family:ziti;
                font-weight:500;
                color:rgba(51,51,51,1);
                line-height:2.093rem;
                margin-bottom: 0.625rem;
              }
              >div:nth-child(2){
                font-size:0.875rem;
                font-family: ziti;
                font-weight:500;
                color:rgba(136,136,136,1);
                line-height:1.25rem;
              }
          }
          .onepx{
              width:0.0625rem;
              height:6rem;
              background:rgba(216,216,216,1);
              margin-top: 1rem;
          }
      }
  }
  .body{
    // flex: 1;
    padding-top: 5rem;
    >ul{
      background:rgba(255,255,255,1);
      li{
        margin: 0 4vw;
        height:3.5625rem;
        display: flex;
        align-items: center;
        position: relative;
        border-bottom: 0.0625rem solid rgba(237,237,237,1);
          .tu1{
            width: 1.3125rem;
            height: 1.3125rem;
          }
          div{
            font-size:1rem;
            font-family:ziti;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:1.4375rem;
            margin-left: 0.625rem;
          }
          .tu2{
            width: 0.5625rem;
            height: 0.9375rem;
            position: absolute;
            right: 0;
          }
      }
      li:nth-child(3){
        border-bottom: none;
      }
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/view/Commissionbalance.vue